/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { googleCalendarEventsControllerCreateEvent } from '../fn/google-calendar-events/google-calendar-events-controller-create-event';
import { GoogleCalendarEventsControllerCreateEvent$Params } from '../fn/google-calendar-events/google-calendar-events-controller-create-event';
import { googleCalendarEventsControllerDeleteEvent } from '../fn/google-calendar-events/google-calendar-events-controller-delete-event';
import { GoogleCalendarEventsControllerDeleteEvent$Params } from '../fn/google-calendar-events/google-calendar-events-controller-delete-event';
import { googleCalendarEventsControllerUpdateEvent } from '../fn/google-calendar-events/google-calendar-events-controller-update-event';
import { GoogleCalendarEventsControllerUpdateEvent$Params } from '../fn/google-calendar-events/google-calendar-events-controller-update-event';

@Injectable({ providedIn: 'root' })
export class GoogleCalendarEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `googleCalendarEventsControllerCreateEvent()` */
  static readonly GoogleCalendarEventsControllerCreateEventPath = '/thalea-google-events/google-calendar-events';

  /**
   * Create a google calendar event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarEventsControllerCreateEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarEventsControllerCreateEvent$Response(params: GoogleCalendarEventsControllerCreateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return googleCalendarEventsControllerCreateEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a google calendar event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarEventsControllerCreateEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarEventsControllerCreateEvent(params: GoogleCalendarEventsControllerCreateEvent$Params, context?: HttpContext): Observable<void> {
    return this.googleCalendarEventsControllerCreateEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `googleCalendarEventsControllerUpdateEvent()` */
  static readonly GoogleCalendarEventsControllerUpdateEventPath = '/thalea-google-events/google-calendar-events/{tenant}/{organizerEmail}/{eventId}/{createdAt}';

  /**
   * Update a google calendar event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarEventsControllerUpdateEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarEventsControllerUpdateEvent$Response(params: GoogleCalendarEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return googleCalendarEventsControllerUpdateEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a google calendar event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarEventsControllerUpdateEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  googleCalendarEventsControllerUpdateEvent(params: GoogleCalendarEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<void> {
    return this.googleCalendarEventsControllerUpdateEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `googleCalendarEventsControllerDeleteEvent()` */
  static readonly GoogleCalendarEventsControllerDeleteEventPath = '/thalea-google-events/google-calendar-events/{tenant}/{organizerEmail}/{eventId}/{createdAt}/{entity}';

  /**
   * Delete a google calendar event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarEventsControllerDeleteEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarEventsControllerDeleteEvent$Response(params: GoogleCalendarEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return googleCalendarEventsControllerDeleteEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a google calendar event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarEventsControllerDeleteEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarEventsControllerDeleteEvent(params: GoogleCalendarEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<void> {
    return this.googleCalendarEventsControllerDeleteEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
